<template>
  <div id="Libraries">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
   <!-- <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed> -->
    <div class="body mb gutter-lg">
      <h2>Libraries</h2>
      <address>
        <strong>Accounting Library</strong><br />
        Accounting 105<br />
        <a href="https://libraries.usc.edu/locations/accounting-library" class="inline-hyperlink" target="_blank">https://libraries.usc.edu/locations/accounting-library</a><br />
        (213) 740-5027
      </address>

      <address>
        <strong>Gaughan & Tiberti Business Library</strong><br />
        Fertitta Hall 101<br />
        <a href="https://libraries.usc.edu/locations/gaughan-tiberti-library" class="inline-hyperlink" target="_blank">https://libraries.usc.edu/locations/gaughan-tiberti-library</a><br />
        (213) 740-8520
      </address>

      <address>
        <strong>Doheny Memorial Library</strong><br />
        3550 Trousdale Parkway<br />
        <a href="https://libraries.usc.edu/locations/doheny-memorial-library" class="inline-hyperlink" target="_blank">https://libraries.usc.edu/locations/doheny-memorial-library</a><br />
        (213) 740-2924
      </address>

      <address>
        <strong>Leavey Library</strong><br />
        651 West 35th Street<br />
        <a href="mailto:lvy@usc.edu" class="inline-hyperlink">lvy@usc.edu</a><br />
        <a href="https://libraries.usc.edu/locations/leavey-library" class="inline-hyperlink" target="_blank">https://libraries.usc.edu/locations/leavey-library</a><br />
      </address>
      </div>
    </div>
</template>

<script>

import hero from '@/components/Hero'
import intro from '@/components/Intro'
import cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'
import linkGroup from '@/components/LinkGroup'

export default {
  name: 'Libraries',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': cta,
    'usc-videoEmbed': videoEmbed,
    'usc-linkGroup': linkGroup
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Libraries',
        loResSrc: '../../../static/HeroImages/Resources3.jpg',
        hiResSrc: '../../../static/HeroImages/Resources3.jpg'
      },
      intro: [
        'There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'
      ],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [
            {
              text: 'USC',
              url: 'https://www.usc.edu/'
            },
            {
              text: 'USC Marshall',
              url: 'https://www.marshall.usc.edu/'
            }
          ]
        },
        1: {
          title: 'Helpful Web Links',
          links: [
            {
              text: 'Academic Calendar',
              url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
            },
            {
              text: 'Athletics',
              url: 'http://usctrojans.com/'
            },
            {
              text: 'Bookstore',
              url: 'https://www.uscbookstore.com/'
            },
            {
              text: 'Catalogue',
              url: 'http://catalogue.usc.edu/'
            },
            {
              text: 'Class Schedule',
              url: 'http://classes.usc.edu/'
            },
            {
              text: 'Center for Black Cultural and Student Affairs',
              url: 'https://cbcsa.usc.edu/'
            },
            {
              text: 'El Centro Chicano',
              url: 'http://sait.usc.edu/elcentro/'
            },
            {
              text: 'Financial Aid',
              url: 'https://financialaid.usc.edu/'
            },
            {
              text: 'Housing',
              url: 'http://housing.usc.edu/'
            },
            {
              text: 'Marshall Mashup (Current Student Blogs)',
              url: 'http://marshallmashup.usc.edu'
            },
            {
              text: 'OASIS',
              url: 'https://usc.edu/OASIS'
            },
            {
              text: 'Orientation',
              url: 'https://orientation.usc.edu/'
            },
            {
              text: 'Recreational Sports',
              url: 'https://sait.usc.edu/recsports/'
            },
            {
              text: 'Student Health Center',
              url: 'http://engemannshc.usc.edu/'
            },
            {
              text: 'Student Organizations',
              url: 'http://campusactivities.usc.edu/'
            },
            {
              text: 'Transportation Services',
              url: 'http://transnet.usc.edu/'
            },
            {
              text: 'Undergraduate Admissions',
              url: 'http://admit.usc.edu/'
            },
            {
              text: 'Volunteer Center',
              url: 'http://campusactivities.usc.edu/'
            }
          ]
        }
      }
    }
  },
  created () {
    this.$root.setPageHeader('Resources', 'Libraries')
  }
}
</script>
<style scoped lang="scss">
  @import '~styles/vars';
  #c5-wrapper {
    h4 {
      margin-bottom: 10px;
    }
    address {
      margin-bottom: 25px;
      font-style: normal;
    }
    .resources-link {
      color: $cBody;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/resources/Libraries.vue